import { getStaffScopedApiPrefixOrCareAdvisor } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import {
  CreateOralHealthCoachingReportCarePlanParams,
  CreateOralHealthCoachingReportEducationParams,
  CreateOralHealthCoachingReportGoalParams,
  CreateOralHealthCoachingReportInternalNoteParams,
  CreateOralHealthCoachingReportMediaParams,
  ObjectType,
  OralHealthCoachingReport,
} from './types/types';

export const addOralHealthCoachingReportObject = async (
  oral_health_coaching_report_id: string,
  object_type: ObjectType,
  payload:
    | CreateOralHealthCoachingReportInternalNoteParams
    | CreateOralHealthCoachingReportGoalParams
    | CreateOralHealthCoachingReportEducationParams
    | CreateOralHealthCoachingReportCarePlanParams
    | CreateOralHealthCoachingReportMediaParams,
  userRole?: string,
): Promise<OralHealthCoachingReport> => {
  const prefix = getStaffScopedApiPrefixOrCareAdvisor(userRole);
  const { data } = await client.post<OralHealthCoachingReport>(
    `${prefix}/oral_health_coaching_reports/${oral_health_coaching_report_id}/${object_type}`,
    payload,
  );

  return data;
};
